import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import RenewalAreTheNewArr from '../components/RenewalsAreTheNewArr'

export default function RenewalsAreTheArr4SmartWaystoBuildDriveGrowthWithRenewalIntelligence() {
  return (
    <div>
      <Header1/>
      <RenewalAreTheNewArr/>
      <Footer/>
    </div>
  )
}
